// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		
        { 
			title: "Topic or Keyword", 
			attr: "content",  
			value: "", 
			id:"topic",
			placeholder: "Topic or Keyword", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "Topic or Keyword", 
			attr: "content",  
			value: "Writing", 
			id:"topic",
			placeholder: "Topic or Keyword", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required "),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`Q: What are the basics of good writing?\nA: Good writing typically consists of a clear structure, well-crafted sentences, strong vocabulary, and correct grammar and punctuation.
		\nQ: How can I improve  my writing skills?\nA: To improve your writing skills, read widely to gain knowledge in your chosen topic; practice regularly by writing on different topics; get feedback from others; and use online resources such as grammar guides to help you identify areas for improvement.
		\nQ: What is the best way to organize a piece of writing?\nA: The best way to organize a piece of writing is by creating an outline that includes an introduction, body paragraphs with supporting evidence or examples, and a conclusion. This structure will help guide you in crafting your argument and ensure that all necessary points are addressed. 
		\nQ: What should I do if I am having trouble coming up with ideas for my paper?\nA: If you’re having trouble coming up with ideas for your paper, try brainstorming or freewriting to generate some potential topics or angles for your argument. You can also look at other research papers in the same field for inspiration. `, 
		
        
        // Console\n1. What is the best gaming console?\n2. What features do gaming consoles offer?
	}
	}
	
	
	export default obj
	
	